import type { Filter } from '@/serverSideTable/materializedTables/materializedTables.constants';
import type { ColumnFilterUiHint } from '@seeqdev/api/model/ColumnFilterUiHint';
import type { Filter as SdkFilter } from '@seeqdev/api/model/Filter';
import type { FilterSpecV1 } from '@seeqdev/api/model/FilterSpecV1';

/**
 * Table-definition / hierarchy `filterSpec` types (CRAB-62372) now come from the generated SDK.
 * Re-exported here so table-editor code has a single import site.
 */
export type { ColumnFilterUiHint, FilterSpecV1 };

/** Items that may carry a persisted filter spec from the API. */
export type WithFilterSpec = {
  filterSpec?: FilterSpecV1 | null;
};

/** Converts the local table-filter union into the SDK Filter object used by FilterSpecV1 / queryTableData. */
export const toSdkFilter = (filter: Filter): SdkFilter => filter as SdkFilter;

export const toFilterSpec = (filter: Filter | null | undefined): FilterSpecV1 | undefined =>
  filter ? { filter: toSdkFilter(filter) } : undefined;

export const readFilterSpec = (item: WithFilterSpec | null | undefined): FilterSpecV1 | undefined =>
  item?.filterSpec ?? undefined;
